import React from 'react'
import SettingSeoForm from '../components/setting/settingSeoForm'

const SettingsSeo = () => {
    return (
        <>
            <SettingSeoForm />
        </>
    )
}

export default SettingsSeo